import React from 'react';
import './SectionHeading.css';

const SectionHeading = ({
  eyebrow,
  title,
  description,
  align = 'center',
  tone = 'default',
  className = '',
  children,
}) => {
  const classes = ['section-heading', `section-heading--${align}`, `section-heading--${tone}`, className]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes}>
      {eyebrow && <p className="section-heading__eyebrow">{eyebrow}</p>}
      {title && <h2 className="section-heading__title">{title}</h2>}
      {description && <p className="section-heading__description">{description}</p>}
      {children}
    </div>
  );
};

export default SectionHeading;
